<template>
  <div class="container bord">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-sm-offset-6 col-md-6 col-md-offset-6">
        <h1 class="text-center" style="margin-top: 10px;">Multiply &amp; Divide Quiz</h1>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-sm-offset-6 col-md-6 col-md-offset-6">
        <app-question :key="questionKey"></app-question>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "../views/maths/timesdiv/Times&Divide.vue";

export default {
  components: { appQuestion: Question },
  data() {
    return { questionKey: 0 };
  },
};
</script>

<style scoped>
.bord { min-height: 65vh; }
</style>
